import { render, staticRenderFns } from "./ArticleMultiDeleteDialog.vue?vue&type=template&id=0f66634c"
import script from "./ArticleMultiDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleMultiDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports